// English source strings also serve as the fallback catalog.
export default {
    'Create': '作成',
    'Create a GLB+ with States': 'ステート付きGLB+を作成',
    'Scan a floor or table, then tap Place model.': '床やテーブルにカメラを向けて、「モデルを配置」をタップしてください。',
    'AR by Niantic Spatial': 'ARエンジン提供：Niantic Spatial',
    'License and warranty disclaimer': 'ライセンス・保証に関する免責事項',
    'AR controls': 'AR操作',
    'Reposition': '再配置',
    'Place model': 'モデルを配置',
    'Scanning…': 'スキャン中…',
    'Walk around your model': 'モデルの周りを歩いて見てみましょう',
    'Surface found — tap Place model': '配置できます。「モデルを配置」をタップ',
    'Move slowly and scan a well-lit, textured surface': '明るく模様のある面にカメラを向け、ゆっくり動かしてください',
    'Scan a surface to place again': '再配置する面にカメラを向けてください',
    'Allow camera and motion access to start AR': 'ARを開始するにはカメラとモーションへのアクセスを許可してください',
    'Loading AR…': 'ARを読み込み中…',
    'AR could not continue': 'ARを続行できませんでした',
    'Load a model before entering AR.': 'ARを開始する前にモデルを読み込んでください。',
    'The model has no usable bounds.': 'モデルのサイズを取得できませんでした。',
    'Markerless AR is not supported by this device and browser.': 'この端末とブラウザーはマーカーレスARに対応していません。',
    'Camera access was denied. Allow it in browser settings and try again.': 'カメラへのアクセスが拒否されました。ブラウザーの設定で許可して、再度お試しください。',
    'The camera could not start. Close other camera apps and try again.': 'カメラを起動できませんでした。他のカメラアプリを閉じて、再度お試しください。',
    'AR startup timed out. Please try again.': 'ARの起動がタイムアウトしました。再度お試しください。',
    'Enter markerless AR': 'マーカーレスARを開始',
    'Retry': '再試行',
    'Choose file…': 'ファイルを選択…',
    'Details': '詳細',
    'Saving scene': 'シーンを保存しています',
    'Saving the scene file. Choose a location if prompted.': 'シーンファイルを保存しています。保存先を求められた場合は選択してください。',
    'Opening scene': 'シーンを開いています',
    'Loading assets. The current scene will be kept until loading succeeds.': 'アセットを読み込んでいます。読み込みが完了するまで、現在のシーンは保持されます。',

    "Unsaved scene": "未保存のシーン",
    "Save your changes before opening another scene?": "別のシーンを開く前に変更を保存しますか？",
    "Save and open": "保存して開く",
    "Discard changes": "変更を破棄",
    "Missing scene asset": "シーンのアセットが見つかりません",
    "Locate {name}. The current scene will be kept if you cancel.": "{name}を指定してください。キャンセルすると現在のシーンが保持されます。",
    "Skip opens the scene with the default background.": "スキップすると、標準の背景でシーンを開きます。",
    "Skip opens the scene without this model.": "スキップすると、このモデルを除いてシーンを開きます。",
    "Browse for replacement…": "代わりのファイルを選択…",
    "Asset URL": "アセットのURL",
    "Use URL": "このURLを使用",
    "Retry original asset": "元のアセットを再試行",
    "Skip": "スキップ",
    "Choose an HDR or GLB background file.": "HDRまたはGLB背景ファイルを選択してください。",
    "Choose one GLB, glTF, or FBX model, with any companion files.": "GLB、glTF、FBXモデルを1つ選択してください。必要な関連ファイルも一緒に選択できます。",
    "Enter an HTTP or HTTPS asset URL.": "HTTPまたはHTTPSのアセットURLを入力してください。",
    "This background type is not supported by the web viewer.": "この背景の種類はWebビューアーではサポートされていません。",
    "Open scene cancelled. The current scene was kept.": "シーンを開く操作をキャンセルしました。現在のシーンは保持されています。",
    "Layout loaded. Skipped {count} asset(s): {names}": "レイアウトを読み込みました。{count}個のアセットをスキップしました：{names}",
    "Desktop state selections and transform locks are preserved but not applied.": "デスクトップ版の状態選択と変形ロックは保持されますが、適用されません。",
    "Layout loaded. Desktop state selections and transform locks are preserved in the file but are not applied by the web viewer.": "レイアウトを読み込みました。デスクトップ版の状態選択と変形ロックはファイルに保持されますが、Webビューアーでは適用されません。",
    "Unable to save layout: {reason}": "レイアウトを保存できません：{reason}",
    "Unable to load layout: {reason}": "レイアウトを読み込めません：{reason}",
    "Wait for loading to finish before saving or loading a layout.": "読み込みが完了してからレイアウトを保存または読み込んでください。",
    "Select exactly one .mvscene file, optionally with its model, texture, and HDR files.": ".mvsceneファイルを1つ選択してください。モデル、テクスチャ、HDRファイルも一緒に選択できます。",
    "Missing asset: {name}. Select it together with the .mvscene file, or add its library first.": "アセットが見つかりません：{name}。.mvsceneファイルと一緒に選択するか、先にライブラリーを追加してください。",
    "Reconnect the library for {name}, then load the layout again.": "{name}のライブラリーを再接続してから、レイアウトを再度読み込んでください。",
    "Ambiguous asset: {name}": "同じ名前のアセットが複数あります：{name}",
    "A saved state is unavailable in {name}.": "{name}には保存された状態がありません。",
    "This scene format or version is not supported.": "このシーンの形式またはバージョンはサポートされていません。",
    "The scene is missing its models or environment.": "シーンにモデルまたは環境の情報がありません。",
    "Scene model identifiers must be unique and nonempty.": "シーン内のモデルIDは空にできず、重複もできません。",
    "A scene model has no asset reference.": "シーン内のモデルにアセットの参照情報がありません。",
    "The scene contains an invalid transform.": "シーンに無効な変形データがあります。",
    "The scene contains invalid state selections.": "シーンに無効な状態選択があります。",
    "The scene contains an invalid presentation transform.": "シーンに無効な表示用の変形データがあります。",
    "Invalid presentation rotation.": "表示用の回転データが無効です。",
    "Unknown scene background type.": "シーンの背景の種類が不明です。",
    "Missing background asset.": "背景アセットの情報がありません。",
    "The scene file is empty or too large.": "シーンファイルが空か、サイズが大きすぎます。",
    "The scene file is too large.": "シーンファイルのサイズが大きすぎます。",
    "The scene file contains invalid JSON.": "シーンファイルのJSON形式が無効です。",
    "Unable to load this asset. Choose a replacement or retry.": "このアセットを読み込めません。代わりのファイルを選択するか、再試行してください。",
    "Technical details": "技術的な詳細",

    'Layout name': 'レイアウト名',
    'Save cancelled. The current scene was kept.': '保存をキャンセルしました。現在のシーンは保持されています。',
    'Save Scene As': '名前を付けてシーンを保存',
    'File name': 'ファイル名',
    'Save Scene': 'シーンを保存',
    'Load Scene': 'シーンを読み込む',
    'Layout loaded.': 'レイアウトを読み込みました。',
    'Saving layout…': 'レイアウトを保存中…',
    'Loading layout…': 'レイアウトを読み込み中…',
    'Layout saved. Asset files are referenced, not embedded.': 'レイアウトを保存しました。アセットファイルは参照され、埋め込まれません。',
    'Load one .mvscene file. Include local model, texture, and HDR files if they are not in your libraries. Loading replaces the scene.': '.mvscene ファイルを1つ選択してください。ライブラリーにないモデル、テクスチャ、HDRファイルも一緒に選択してください。読み込むとシーンが置き換わります。',

    'Language': '言語',
    'Signed out.': 'ログアウトしています。',
    'Signing in...': 'ログイン中…',
    '{count} Credit': '{count}クレジット',
    '{count} Credits': '{count}クレジット',
    'the selected model': '選択したモデル',
    'Library type must be model or background.': 'ライブラリーの種類はモデルまたは背景である必要があります。',
    'Choose a folder containing supported assets.': '対応するアセットを含むフォルダーを選択してください。',
    'No GLB, glTF, or FBX files were found in that folder.': 'このフォルダーにはGLB、glTF、FBXファイルがありません。',
    'No HDR or GLB files were found in that folder.': 'このフォルダーにはHDRまたはGLBファイルがありません。',
    'Choose a local folder.': 'ローカルフォルダーを選択してください。',
    'The validation generated {total} warnings. {count} of these warnings have been about missing tangent space information. Omitting the tangent space information may be a conscious decision by the designer, but it may limit the portability of the asset. The glTF-Sample-Viewer generates tangents using the default MikkTSpace algorithm in this case.': '検証で{total}件の警告が発生しました。そのうち{count}件は接空間情報の不足に関するものです。制作者が意図的に省略している場合もありますが、アセットの互換性が制限される可能性があります。この場合、glTF-Sample-Viewerは標準のMikkTSpaceアルゴリズムで接線を生成します。',
    'Choose the viewer language': 'ビューアーの表示言語を選択',
    'Language could not be saved in this browser.': 'このブラウザーでは言語設定を保存できませんでした。',
    'No Canvas!': 'Canvasに対応していません。',
    'Variant:': 'バリアント：',
    'Asset loading progress': 'アセットの読み込み状況',
    'Drop a GLB, glTF, FBX, or HDR file': 'GLB、glTF、FBX、HDRファイルをドロップ',
    'Visit INNOWORKS': 'INNOWORKSのサイトを開く',
    'Transform tools': '変形ツール',
    'Hand / free move (Q)': 'ハンド／自由移動（Q）',
    'Hand': 'ハンド',
    'Move (W)': '移動（W）',
    'Move': '移動',
    'Rotate (E)': '回転（E）',
    'Rotate': '回転',
    'Scale (R)': '拡大・縮小（R）',
    'Scale': 'スケール',
    'Frame selected model': '選択したモデルを画面に収める',
    'Frame': '全体表示',
    'Open help and documentation': 'ヘルプとドキュメントを開く',
    'Help': 'ヘルプ',
    'Toggle fullscreen': '全画面表示を切り替え',
    'Fullscreen': '全画面',
    'Library navigation': 'ライブラリーの切り替え',
    'Models': 'モデル',
    'Backgrounds': '背景',
    'Scene': 'シーン',
    'Model library': 'モデルライブラリー',
    'Samples': 'サンプル',
    'Filter models': 'モデルを絞り込み',
    'Load local GLB or FBX': 'ローカルのGLB／FBXを読み込む',
    'Link local model folder': 'ローカルのモデルフォルダーをリンク',
    'No matching models.': '該当するモデルがありません。',
    'models ·': 'モデル ·',
    'Add model library folder': 'モデルライブラリーのフォルダーを追加',
    'Background library': '背景ライブラリー',
    'Environments': '環境',
    'Image-based lighting': '画像ベースの照明',
    'Load local HDR or GLB': 'ローカルのHDRまたはGLBを読み込む',
    'HDR or GLB': 'HDRまたはGLB',
    'Link local background folder': 'ローカルの背景フォルダーをリンク',
    'backgrounds ·': '背景 ·',
    'Add background library folder': '背景ライブラリーのフォルダーを追加',
    'Clear': 'クリア',
    'No models are loaded.': 'モデルが読み込まれていません。',
    'Remove': '削除',
    'PROPERTIES': 'プロパティ',
    'Properties': 'プロパティ',
    'Remove selected model': '選択したモデルを削除',
    'Select a model to inspect its transform, states, and analysis.': 'モデルを選択すると、変形・状態・分析を確認できます。',
    'Transform': '変形',
    'States': '状態',
    'Analyze': '分析',
    'Position': '位置',
    'Rotation': '回転',
    'Frame selected': '選択対象を全体表示',
    'This model has no configurable states.': 'このモデルには切り替え可能な状態がありません。',
    'Material variants': 'マテリアルバリアント',
    'Meshes': 'メッシュ',
    'Triangles': '三角形',
    'Errors': 'エラー',
    'Warnings': '警告',
    'Information': '情報',
    'Asset': 'アセット',
    'Generator:': '生成ツール：',
    'Copyright:': '著作権：',
    'glTF Validator': 'glTF検証ツール',
    'Copy report': 'レポートをコピー',
    'Download report': 'レポートをダウンロード',
    'Full validation report': '検証レポートの詳細',
    'Detailed statistics': '詳細な統計',
    'Show renderer statistics': 'レンダラーの統計を表示',
    'CREATE': '作成',
    'AI Enhance': 'AI高画質化',
    'Model': 'モデル',
    'Image generation model': '画像生成モデル',
    'AI model': 'AIモデル',
    'Resolution': '解像度',
    'Generated image size': '生成画像のサイズ',
    'AI resolution': 'AI画像の解像度',
    'Aspect ratio': '縦横比',
    'Generated image framing': '生成画像の縦横比',
    'AI aspect ratio': 'AI画像の縦横比',
    'Prompt': 'プロンプト',
    'AI enhancement prompt': 'AI高画質化のプロンプト',
    'Describe the enhancement you want...': '希望する画像の仕上がりを入力…',
    'credits remaining today': 'クレジット（本日の残り）',
    'Sign in': 'ログイン',
    'Complete setup': '設定を完了',
    'Sign out': 'ログアウト',
    'Results': '生成結果',
    'Open preview': 'プレビューを開く',
    'Set as 3D background': '3D背景に設定',
    'Download image': '画像をダウンロード',
    'Enhance (': '高画質化 (',
    'Clear generated background': '生成した背景を解除',
    'Images are sent directly between this browser and Google for generation. They are not sent to an INNOWORKS server.': '画像生成のため、画像はこのブラウザーとGoogleの間で直接送受信されます。INNOWORKSのサーバーには送信されません。',
    'VIEW': '表示',
    'Camera': 'カメラ',
    'Projection': '投影方式',
    'Perspective or orthographic view': '透視投影または平行投影',
    'Perspective': '透視投影',
    'Orthographic': '平行投影',
    'Field of view': '画角',
    'Orthographic size': '平行投影のサイズ',
    'SETTINGS': '設定',
    'Visuals': '描画設定',
    'Ambient occlusion': 'アンビエントオクルージョン',
    'Add depth to creases and contact points': 'くぼみや接触部分に陰影を追加',
    'AO method': 'AO方式',
    'Compare ambient shading': '環境陰影の方式を選択',
    'GTAO (half resolution)': 'GTAO（1/2解像度）',
    'GTAO (quarter resolution)': 'GTAO（1/4解像度）',
    'SSAO (basic)': 'SSAO（基本）',
    'N8AO (performance)': 'N8AO（高速）',
    'AO intensity': 'AOの強度',
    'Use the selected HDR environment': '選択したHDR環境を使用',
    'Show background': '背景を表示',
    'Keep HDR lighting while showing a solid colour': 'HDR照明を維持して単色の背景を表示',
    'Ground plane': '地面',
    'Perspective and shadow reference': '遠近感と影の基準面',
    'IBL intensity': 'IBLの強度',
    'HDR background blur': 'HDR背景のぼかし',
    'Punctual lights': 'モデル内のライト',
    'Sun and model lights': '太陽とモデル内のライト',
    'Direct lighting and shadows': '直接照明と影',
    'Shadow strength': '影の濃さ',
    'Lights embedded in the model': 'モデルに含まれるライトを使用',
    'Light direction': 'ライトの方向',
    'Light height': 'ライトの高さ',
    'Exposure': '露出',
    'Tone map': 'トーンマッピング',
    'Output color transform': '出力時の色変換',
    'Background colour': '背景色',
    'Used when the background is hidden': '背景を非表示にしたときの色',
    'Environment rotation': '環境の回転',
    'Rotate HDR lighting around the model': 'モデルの周囲でHDR照明を回転',
    'Ground-plane height': '地面の高さ',
    'TOOLS': 'ツール',
    'Annotate': '注釈',
    'Pen annotation': 'ペンで注釈',
    'Draw directly over the 3D view': '3Dビューに直接描画',
    'Colour': '色',
    'Custom pen colour': 'ペンの色を選択',
    'Pen width': 'ペンの太さ',
    'Undo': '元に戻す',
    'Redo': 'やり直す',
    'Shortcuts': 'ショートカット',
    'Draw with the pointer over the 3D view. Use Ctrl/Cmd+Z to undo and Ctrl/Cmd+Shift+Z to redo.': '3Dビュー上でポインターを使って描画します。Ctrl/Cmd+Zで元に戻し、Ctrl/Cmd+Shift+Zでやり直します。',
    'System': 'システム',
    'Web viewer': 'ウェブビューアー',
    'This interface uses the Model Vista GLB+ runtime and renderer.': 'このビューアーはModel Vista GLB+ランタイムとレンダラーを使用しています。',
    'Help and documentation': 'ヘルプとドキュメント',
    'Open the Model Vista Web guide for instructions, controls, and troubleshooting.': '操作方法やトラブルの解決方法は、Model Vista Webガイドをご覧ください。',
    'Open documentation': 'ドキュメントを開く',
    'Viewer settings': 'ビューアー設定',
    'Reset viewer settings': 'ビューアー設定をリセット',
    'User libraries': 'ユーザーライブラリー',
    'Selected local folders are linked on this device and restored automatically. Nothing is uploaded.': '選択したローカルフォルダーはこの端末にリンクされ、自動的に復元されます。ファイルはアップロードされません。',
    'This browser keeps a local browser copy so libraries can be restored. Nothing is uploaded.': 'ライブラリーを復元できるよう、このブラウザー内にコピーを保存します。ファイルはアップロードされません。',
    'Add models': 'モデルを追加',
    'Add backgrounds': '背景を追加',
    'Library name': 'ライブラリー名',
    'library ·': 'ライブラリー ·',
    'assets ·': 'アセット ·',
    'No user libraries have been added.': 'ユーザーライブラリーはまだありません。',
    'Inspector navigation': 'インスペクターの切り替え',
    'LOCAL LIBRARY ACCESS': 'ローカルライブラリーへのアクセス',
    'Your files stay in their source folder': 'ファイルは元のフォルダーに保持されます',
    'Model Vista is requesting read-only access so it can display models or backgrounds directly from the folder you select.': '選択したフォルダーからモデルや背景を直接表示するため、Model Vistaは読み取り専用アクセスを要求します。',
    'It does not copy, upload, modify, or delete your files. Your browser may still describe read access as permission to “view and copy files.”': 'ファイルのコピー・アップロード・変更・削除は行いません。ブラウザーには読み取り権限が「ファイルの表示とコピー」と表示される場合があります。',
    'This browser cannot retain a direct folder link. Model Vista will keep a local browser copy so the library can be restored.': 'このブラウザーではフォルダーへのリンクを保持できないため、復元用のコピーをブラウザー内に保存します。',
    'Nothing is uploaded to a server, and your original files are never modified or deleted.': 'サーバーへのアップロードや元のファイルの変更・削除は行いません。',
    'Cancel': 'キャンセル',
    'Continue to folder selection': 'フォルダーの選択へ進む',
    'AI result preview': 'AI生成結果のプレビュー',
    'Close preview': 'プレビューを閉じる',
    'Close account dialog': 'アカウント画面を閉じる',
    'AI Enhance account': 'AI高画質化のアカウント',
    'Email': 'メールアドレス',
    'Password': 'パスワード',
    'Sign up': '新規登録',
    'Forgot password': 'パスワードを再設定',
    'Resend verification': '確認メールを再送',
    'Enter AR': 'ARを開始',
    'Exit AR': 'ARを終了',
    'AR model size': 'ARモデルのサイズ',
    'Make AR model smaller': 'ARモデルを縮小',
    'MODEL SIZE': 'モデルサイズ',
    'PHYSICAL SCALE': '実寸スケール',
    'Make AR model larger': 'ARモデルを拡大',
    'MARKER-DEFINED WORLD': 'マーカー基準の空間',
    'Set up AR': 'ARの設定',
    'The marker center becomes scene origin (0,0,0), and every loaded model keeps its scene transform.': 'マーカーの中心がシーンの原点（0,0,0）になります。読み込んだ各モデルの位置・回転・スケールは維持されます。',
    'Close AR setup': 'AR設定を閉じる',
    'Auto fit': '自動調整',
    'Printed marker width': '印刷したマーカーの幅',
    'Initial model size': '初期モデルサイズ',
    '100% automatically fits the loaded scene to the marker.': '100%でシーン全体をマーカーに合わせて自動調整します。',
    'Physical scale': '実寸スケール',
    'The printed marker width calibrates the scene so 1 glTF unit equals 1 metre.': '印刷したマーカーの幅を基準に、glTFの1単位が1メートルになるよう調整します。',
    'Tracking image:': 'トラッキング画像：',
    'Use bundled marker': '付属のマーカーを使用',
    'Print marker': 'マーカーを印刷',
    'Print at 100% / Actual Size, or show the marker on another screen.': '100%／実際のサイズで印刷するか、別の画面にマーカーを表示してください。',
    'This browser cannot start camera AR here. Use HTTPS or localhost on a camera-enabled browser.': 'ここではカメラARを開始できません。カメラ対応ブラウザーでHTTPSまたはlocalhostを使用してください。',
    'MODEL VISTA · AR ORIGIN': 'MODEL VISTA · AR原点',
    'Marker center = scene origin (0,0,0). Print at 100% / Actual Size with page scaling disabled.': 'マーカーの中心＝シーンの原点（0,0,0）。ページの拡大・縮小を無効にして100%／実際のサイズで印刷してください。',
    'Drag and drop files here': 'ここにファイルをドラッグ＆ドロップ',
    'Supported files: glTF, glb, fbx & hdr': '対応ファイル：glTF、glb、fbx、hdr',
    'Add Model': 'モデルを追加',
    'Browse Models': 'モデルを選ぶ',
    'Load Local GLB/FBX': 'ローカルのGLB／FBXを読み込む',
    'Loaded Models': '読み込み済みのモデル',
    'Load a model to start.': 'モデルを読み込んで開始してください。',
    'Selected:': '選択中：',
    'Move Selected (X)': '選択対象を移動（X）',
    'Move Selected (Y)': '選択対象を移動（Y）',
    'Move Selected (Z)': '選択対象を移動（Z）',
    'Rotate Selected (X°)': '選択対象を回転（X°）',
    'Rotate Selected (Y°)': '選択対象を回転（Y°）',
    'Rotate Selected (Z°)': '選択対象を回転（Z°）',
    'Scale Selected (X)': '選択対象のスケール（X）',
    'Scale Selected (Y)': '選択対象のスケール（Y）',
    'Scale Selected (Z)': '選択対象のスケール（Z）',
    'Frame Selected': '選択対象を全体表示',
    'Remove Selected': '選択対象を削除',
    'Clear All': 'すべてクリア',
    'Variants': 'バリアント',
    'Model data is loaded locally. No data is sent to the INNOWORKS server.': 'モデルデータはローカルで読み込まれます。INNOWORKSのサーバーには送信されません。',
    'Select a Model': 'モデルを選択',
    'Search models...': 'モデルを検索…',
    'No sample models match your search.': '検索に一致するサンプルモデルはありません。',
    'Aspect Ratio': '縦横比',
    'Credits:': 'クレジット：',
    'remaining today': '（本日の残り）',
    'Enhance selected image': '選択画像を高画質化',
    'Clear 3D Background': '3D背景を解除',
    'Sign In': 'ログイン',
    'Sign Out': 'ログアウト',
    'Account': 'アカウント',
    'Sign Up': '新規登録',
    'Forgot Password': 'パスワードを再設定',
    'Resend Verification': '確認メールを再送',
    'Data is sent directly between this client and Google. No data is sent to the INNOWORKS server.': 'データはこのブラウザーとGoogleの間で直接送受信されます。INNOWORKSのサーバーには送信されません。',
    'Animation Controls': 'アニメーション操作',
    'Animations': 'アニメーション',
    'Display': '表示',
    'Lighting': '照明',
    'Image Based': '画像ベース',
    'Punctual Lighting': 'モデル内の照明',
    'Light Direction': 'ライトの方向',
    'Light Height': 'ライトの高さ',
    'Camera Projection': 'カメラの投影方式',
    'Camera FOV': 'カメラの画角',
    'Camera Ortho Size': '平行投影のサイズ',
    'Enabled': '有効',
    'IBL Intensity': 'IBLの強度',
    'Tone Map': 'トーンマッピング',
    'Background': '背景',
    'Environment Map': '環境マップ',
    'Blur': 'ぼかし',
    'Background Color': '背景色',
    'Ground Plane': '地面',
    'Enable': '有効にする',
    'Plane Height': '地面の高さ',
    'Environment Rotation': '環境の回転',
    'Image Based Lighting': '画像ベースの照明',
    'Add Background': '背景を追加',
    'Active Environment': '使用中の環境',
    'Pen': 'ペン',
    'Eraser': '消しゴム',
    'Color': '色',
    'Pen Width': 'ペンの太さ',
    'Advanced Controls': '詳細な操作',
    'Advanced': '詳細',
    'Controls': '操作',
    'Statistics': '統計',
    'Number of errors:': 'エラー数：',
    'Number of warnings:': '警告数：',
    'Number of infos:': '情報数：',
    'Copy': 'コピー',
    'Download': 'ダウンロード',
    'Powered by': '提供：',
    'Show left panel': '左パネルを表示',
    'Hide left panel': '左パネルを隠す',
    'Show right panel': '右パネルを表示',
    'Hide right panel': '右パネルを隠す',
    'Show': '表示',
    'Hide': '非表示',
    'No selection': '未選択',
    'Account connected': 'アカウント接続済み',
    'Account setup required': 'アカウント設定が必要です',
    'Account required': 'アカウントが必要です',
    'Sign in to use AI Enhance.': 'AI高画質化を使用するにはログインしてください。',
    'Enhancing 3D view...': '3Dビューを高画質化中…',
    'Enhancing 3D View...': '3Dビューを高画質化中…',
    'Enhance 3D view ({credits})': '3Dビューを高画質化（{credits}）',
    'Enhance 3D View ({credits})': '3Dビューを高画質化（{credits}）',
    'Use {color}': '{color}を使用',
    'Local folder': 'ローカルフォルダー',
    'Local browser copy': 'ブラウザー内のコピー',
    'Reconnect {name}': '{name}を再接続',
    'Remove {name}': '{name}を削除',
    'Bundled marker': '付属のマーカー',
    'Custom marker · current session': 'カスタムマーカー · このセッションのみ',
    'Fit all loaded models to the marker': 'すべてのモデルをマーカーに合わせる',
    '1 glTF unit equals 1 metre': 'glTFの1単位＝1メートル',
    'Fair': '普通',
    'Good': '良好',
    'Poor': '低品質',
    'Preparing…': '準備中…',
    'Create from image': '画像から作成',
    'Starting AR…': 'ARを起動中…',
    'Start AR': 'ARを開始',
    'Enter marker AR': 'マーカーARを開始',
    'Exit marker AR': 'マーカーARを終了',
    'Enter marker-based AR': 'マーカーを使ったARを開始',
    'Loading': '読み込み中',
    'Downloading': 'ダウンロード中',
    'Processing': '処理中',
    'model': 'モデル',
    'background': '背景',
    'Environment': '環境',
    'Loading model…': 'モデルを読み込み中…',
    'Show Options': 'オプションを表示',
    'Hide Options': 'オプションを隠す',
    'Model states': 'モデルの状態',
    'State categories': '状態のカテゴリー',
    'Interactive 3D model': '操作可能な3Dモデル',
    '3D model. Drag to rotate; right-drag or pinch to zoom.': '3Dモデル。ドラッグで回転、右ドラッグまたはピンチで拡大・縮小。',
    'Open the Model Vista website in a new tab?': 'Model Vistaのウェブサイトを新しいタブで開きますか？',
    'Remove {name} from the scene?': 'シーンから{name}を削除しますか？',
    'Clear the scene and remove all loaded models?': 'シーンをクリアして、読み込んだモデルをすべて削除しますか？',
    'Remove “{name}” from Model Vista Web? The original files will not be deleted.': 'Model Vista Webから「{name}」を削除しますか？元のファイルは削除されません。',
    'Saved settings restored.': '保存済みの設定を復元しました。',
    'Settings save automatically in this browser.': '設定はこのブラウザーに自動保存されます。',
    'Settings saved automatically.': '設定を自動保存しました。',
    'Settings could not be saved in this browser.': 'このブラウザーでは設定を保存できませんでした。',
    'Viewer settings restored to defaults.': 'ビューアー設定を初期値に戻しました。',
    'Copied to clipboard': 'クリップボードにコピーしました',
    'Error copying to clipboard.': 'クリップボードへのコピーに失敗しました。',
    'Unable to access local model picker.': 'ローカルモデルの選択画面を開けません。',
    'Please select a .glb, .gltf, or .fbx file.': '.glb、.gltf、.fbxファイルを選択してください。',
    'Please verify your email before using AI Enhance.': 'AI高画質化を使用する前にメールアドレスを確認してください。',
    'Signed in as {email}': '{email}でログイン中',
    'Session expired. Please sign in again.': 'セッションの有効期限が切れました。再度ログインしてください。',
    'Unable to sign in right now.': '現在ログインできません。',
    'Please complete the reCAPTCHA.': 'reCAPTCHAの確認を完了してください。',
    'Username or password incorrect.': 'ユーザー名またはパスワードが正しくありません。',
    'Unable to create account right now.': '現在アカウントを作成できません。',
    'Creating account...': 'アカウントを作成中…',
    'Check your email to verify your account.': '確認メールを開いてアカウントの認証を完了してください。',
    'Email already in use.': 'このメールアドレスはすでに使用されています。',
    'Password is too weak.': 'パスワードの強度が不足しています。',
    'Unable to create account.': 'アカウントを作成できませんでした。',
    'Unable to reset password right now.': '現在パスワードを再設定できません。',
    'Enter your email to reset your password.': 'パスワードを再設定するメールアドレスを入力してください。',
    'Sending reset email...': '再設定メールを送信中…',
    'Password reset email sent.': 'パスワード再設定メールを送信しました。',
    'Unable to send reset email.': '再設定メールを送信できませんでした。',
    'Unable to send verification email.': '確認メールを送信できませんでした。',
    'Please sign in to resend verification.': '確認メールを再送するにはログインしてください。',
    'Verification email sent.': '確認メールを送信しました。',
    'Unable to sign out right now.': '現在ログアウトできません。',
    'Sign out failed.': 'ログアウトに失敗しました。',
    'Setting up AI Enhance...': 'AI高画質化を設定中…',
    'Unable to complete AI Enhance account setup. Please try again.': 'AI高画質化のアカウント設定を完了できませんでした。再度お試しください。',
    'Selected result is unavailable.': '選択した結果を利用できません。',
    'Prompt is required.': 'プロンプトを入力してください。',
    'Please sign in.': 'ログインしてください。',
    'AI Enhance account setup is still completing.': 'AI高画質化のアカウントを設定中です。',
    'Complete your AI Enhance account setup first.': '先にAI高画質化のアカウント設定を完了してください。',
    'You have no credits remaining today.': '本日のクレジット残高がありません。',
    'Complete the reCAPTCHA to finish setting up AI Enhance.': 'reCAPTCHAを完了してAI高画質化の設定を終了してください。',
    'AI Enhance account setup was denied.': 'AI高画質化のアカウント設定が拒否されました。',
    'AI Enhance account setup is rate limited. Please try again later.': 'AI高画質化の設定リクエストが多すぎます。しばらくしてからお試しください。',
    'AI Enhance account setup failed ({status}).': 'AI高画質化のアカウント設定に失敗しました（{status}）。',
    'Unable to restore user libraries: {error}': 'ユーザーライブラリーを復元できません：{error}',
    'Unable to add local folder: {error}': 'ローカルフォルダーを追加できません：{error}',
    'Unable to open the library folder picker.': 'ライブラリーフォルダーの選択画面を開けません。',
    'Adding local folder. Nothing is uploaded.': 'ローカルフォルダーを追加中です。アップロードは行いません。',
    'Read access to that folder was not granted.': 'フォルダーへの読み取りアクセスが許可されませんでした。',
    'Adding a local browser copy. Nothing is uploaded.': 'ブラウザー内にコピーを追加中です。アップロードは行いません。',
    'Requesting access to {name}...': '{name}へのアクセスを要求中…',
    'Unable to reconnect {name}: {error}': '{name}を再接続できません：{error}',
    'That model is no longer available in browser storage.': 'そのモデルはブラウザーの保存領域にありません。',
    'That background is no longer available in browser storage.': 'その背景はブラウザーの保存領域にありません。',
    'Library names cannot be empty.': 'ライブラリー名を入力してください。',
    '{name} renamed.': '{name}に名前を変更しました。',
    'Unable to rename library: {error}': 'ライブラリー名を変更できません：{error}',
    'Unable to remove library: {error}': 'ライブラリーを削除できません：{error}',
    'AR is ready': 'ARの準備ができました',
    'AR requires HTTPS or localhost and a browser with camera access.': 'ARにはHTTPSまたはlocalhostと、カメラへのアクセスが可能なブラウザーが必要です。',
    'Choose or create an AR marker first.': '先にARマーカーを選択または作成してください。',
    'Loading the local AR runtime…': 'ローカルのARランタイムを読み込み中…',
    'The custom marker could not be created.': 'カスタムマーカーを作成できませんでした。',
    'Choose a sharper image with more contrast and detail.': 'コントラストが高く、細部が鮮明な画像を選択してください。',
    'This image has useful contrast and visual detail for local testing.': 'この画像にはローカルテストに適したコントラストと視覚的な特徴があります。',
    'This may track, but a less repetitive image with stronger detail will be steadier.': '認識できる可能性はありますが、繰り返し模様が少なく特徴のはっきりした画像の方が安定します。',
    'Choose a sharper image with more contrast and distinct, asymmetric details.': 'コントラストが高く、非対称で明確な特徴を持つ鮮明な画像を選択してください。',
    'The bundled marker is designed with high-contrast, asymmetric details.': '付属マーカーは高コントラストで非対称な特徴を持つよう設計されています。',
    'The selected marker image could not be decoded.': '選択したマーカー画像を読み取れませんでした。',
    'Choose a PNG, JPEG, WebP, or SVG image for the marker.': 'マーカーにはPNG、JPEG、WebP、SVG画像を選択してください。',
    'Marker images must be at least {width} × {height} pixels.': 'マーカー画像は{width}×{height}ピクセル以上必要です。',
    'Unable to load model: {name}': 'モデルを読み込めません：{name}',
    'Unable to load background: {name}': '背景を読み込めません：{name}',
    'Unable to load this model. Check the model URL and allow cross-origin access (CORS) on its host.': 'モデルを読み込めません。モデルのURLを確認し、配信元でクロスオリジンアクセス（CORS）を許可してください。',
    'Unable to set the selected image as 3D background.': '選択した画像を3D背景に設定できませんでした。',
    'Please sign in again.': '再度ログインしてください。',
    'No model is loaded yet.': 'モデルがまだ読み込まれていません。',
    'AI Enhance failed ({status}).': 'AI高画質化に失敗しました（{status}）。',
    'Account setup required. Please sign in again.': 'アカウント設定が必要です。再度ログインしてください。',
    'AI Enhance failed.': 'AI高画質化に失敗しました。',
    'AI Enhance response did not include image data.': 'AI高画質化の応答に画像データがありませんでした。',
    'Play': '再生',
    'Pause': '一時停止',
    'Preparing': '準備中',
    'Validating': '検証中',
    'None': 'なし',
    'Unavailable': '利用不可',
    'HDR Background': 'HDR背景',
    'Model Background': 'モデル背景',
    'Choose from the same library. None removes only the companion.': '同じライブラリーから選択。「なし」はリンクした背景だけを解除します。',
    'Choose a companion from the same library.': '同じライブラリーからリンクする背景を選択してください。',
    'Choose the opposite background type.': '異なる種類の背景を選択してください。',
    'Missing linked background asset.': 'リンクされた背景アセットの情報がありません。',
    'Background applied, but the link could not be saved in browser storage.': '背景を適用しましたが、リンクをブラウザーに保存できませんでした。',
    'The companion could not load. The current background was kept.': 'リンクする背景を読み込めませんでした。現在の背景は保持されています。',
    'The linked background is unavailable. Choose a replacement or None.': 'リンクされた背景を利用できません。別の背景または「なし」を選択してください。',
    'User Camera': 'ユーザーカメラ',
    'None (Linear mapping, clamped at 1.0)': 'なし（リニア変換、最大1.0）',
    'ACES Filmic Tone Mapping (Hill - Exposure Boost)': 'ACESフィルミック（Hill・露出補正）',
    'ACES Filmic Tone Mapping (Narkowicz)': 'ACESフィルミック（Narkowicz）',
    'ACES Filmic Tone Mapping (Hill)': 'ACESフィルミック（Hill）',
    'Camera access was denied. Allow camera access and try again.': 'カメラへのアクセスが拒否されました。アクセスを許可して再度お試しください。',
    'No usable camera was found on this device.': 'この端末で使用できるカメラが見つかりません。',
    'The camera could not start.': 'カメラを起動できませんでした。',
    'The camera could not start ({reason}).': 'カメラを起動できませんでした（{reason}）。',
    'The local AR runtime could not be loaded.': 'ローカルのARランタイムを読み込めませんでした。',
    'The AR runtime took too long to load.': 'ARランタイムの読み込みがタイムアウトしました。',
    'Image tracking was not included in the loaded AR runtime.': '読み込んだARランタイムに画像トラッキング機能が含まれていません。',
    'Choose a valid marker before starting AR.': 'ARを開始する前に有効なマーカーを選択してください。',
    'Tracking {name}': '{name}をトラッキング中',
    'AR could not start': 'ARを開始できませんでした',
    'Point the camera at the AR marker': 'カメラをARマーカーに向けてください',
    'Marker lost — point the camera at it again': 'マーカーを見失いました。再度カメラを向けてください',
    'Allow camera access to start AR': 'ARを開始するにはカメラへのアクセスを許可してください',
    'Marker lost — hold the camera steady': 'マーカーを見失いました。カメラを動かさずに保持してください',
    'Starting the camera…': 'カメラを起動中…',
    'Access to {name} was not granted. Nothing was uploaded.': '{name}へのアクセスが許可されませんでした。アップロードは行っていません。',
    '{name} reconnected. Nothing was uploaded.': '{name}を再接続しました。アップロードは行っていません。',
    '{name} linked as a local folder with {count} asset. Nothing was uploaded.': '{name}をローカルフォルダーとしてリンクしました（{count}アセット）。アップロードは行っていません。',
    '{name} linked as a local folder with {count} assets. Nothing was uploaded.': '{name}をローカルフォルダーとしてリンクしました（{count}アセット）。アップロードは行っていません。',
    '{name} added with {count} asset. Files remain on this device and are never uploaded.': '{name}を追加しました（{count}アセット）。ファイルはこの端末に保持され、アップロードされません。',
    '{name} added with {count} assets. Files remain on this device and are never uploaded.': '{name}を追加しました（{count}アセット）。ファイルはこの端末に保持され、アップロードされません。'
};
